var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"privpolicy",class:{'privpolicy--offset': _vm.withOffset}},[_vm._v(" "+_vm._s(_vm.$t('callback_popup.privacypolicy.text_1'))+" "),_c('a',{attrs:{"href":_vm.$options.privacyPolicy,"target":"_blank"}},[_vm._v(" "+_vm._s(_vm.$t('callback_popup.privacypolicy.text_2'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }